<template>

    <div class="n2-center-container" style="background-color:#fff; padding:10px;">
        <h5 class="n2-text-center">{{ $t('pages.reset_password.reset_password') }}</h5>
        <div style="max-width:600px;">
            <form-input type="password" v-model="model.password" v-bind:label="$t('pages.reset_password.password')"
                v-bind:errors="model_errors.password"></form-input>
            <form-input type="password" v-model="model.repeat_password"
                v-bind:label="$t('pages.reset_password.repeat_password')"
                v-bind:errors="model_errors.repeat_password"></form-input>
            <validation-summary v-bind:errors="model_errors"></validation-summary>
            <div class="n2-margin-top">
                <button class="n2-button-1"
                    v-on:click="resetPassword">{{ $t('pages.reset_password.set_password') }}</button>
            </div>
            <div class="n2-margin-top">
                <result-summary v-bind:error="result_error"></result-summary>
            </div>
        </div>
        <h5 v-if="result == 'succeeded'">{{ $t('pages.reset_password.succeeded') }}</h5>
        <app-loader v-bind:active="loading"></app-loader>

    </div>
</template>
<script>
import { IdentityService } from '../services'
import AppLoader from '../components/shared/loader.vue'
import FormInput from "../components/shared/form-input.vue"
import ValidationSummary from '../components/shared/validation-summary.vue';
import ResultSummary from '../components/shared/result-summary.vue';


export default {
    components: {
        AppLoader, FormInput, ValidationSummary, ResultSummary
    },
    data: function () {
        return {
            model_errors: {},
            model: {},
            loading: false,
            result: '',
            result_error: ''
        }
    },
    computed: {

    },

    created: function () {
        this.identityService = new IdentityService()

    },
    mounted: async function () {
        this.model = this.$route.query
    },
    methods: {
        validateForm: function () {
            this.model_errors = {}

            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
            if (!strongRegex.test(this.model.password)) {
                this.model_errors['password'] = [this.$t('pages.reset_password.error_password')]
            }
            if (this.model.password != this.model.repeat_password) {
                this.model_errors['repeat_password'] = [this.$t('pages.reset_password.error_password_repeat')]
            }
            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        resetPassword: async function () {
            this.result_error = '';

            if (!this.validateForm()) {
                return
            }
            try {
                console.log(this.model)
                await this.identityService.resetPassword(this.model)
                this.result = 'succeeded'
            }
            catch (err) {
                this.result_error = this.$t('pages.reset_password.failed')

            }
        }
    }
}
</script>
